const IMPERSONATION_FLAG = "adminImpersonating";
const IMPERSONATION_TOKEN = "adminImpersonationToken";

export function getAdminToken() {
  if (sessionStorage.getItem(IMPERSONATION_FLAG) === "true") {
    return sessionStorage.getItem(IMPERSONATION_TOKEN) || "";
  }
  return localStorage.getItem("adminToken") || "";
}

export function isAdminImpersonating() {
  return sessionStorage.getItem(IMPERSONATION_FLAG) === "true";
}

export function setAdminImpersonationToken(token: string) {
  sessionStorage.setItem(IMPERSONATION_FLAG, "true");
  sessionStorage.setItem(IMPERSONATION_TOKEN, token);
}

export function clearAdminImpersonation() {
  sessionStorage.removeItem(IMPERSONATION_TOKEN);
  sessionStorage.removeItem(IMPERSONATION_FLAG);
}
